import React from 'react';
import StatusDotBlueIcon from './icons/status-dot-blue-icon';
import StatusDotGreenIcon from './icons/status-dot-green-icon';
import StatusDotRedIcon from './icons/status-dot-red-icon';
import StatusDotOrangeIcon from './icons/status-dot-orange-icon';
import CampaignConstants from '../constants';
import { Box, Typography } from '@mui/material';
import { createStyleSheet } from 'utils/helpers';

const decideComponentStatusDot = (status: string) => {
    switch (status) {
        case CampaignConstants.status.CLIENT_INPROGRESS:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotGreenIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Đang diễn ra
                    </Typography>
                </Box>
            );
        case CampaignConstants.status.TO_DO:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotGreenIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Chưa diễn ra
                    </Typography>
                </Box>
            );
        case CampaignConstants.status.CLIENT_DRAFT:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotOrangeIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Nháp
                    </Typography>
                </Box>
            );
        case CampaignConstants.status.CLIENT_CLOSED:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotRedIcon />
                    <Typography component="span" sx={styles.textStatus}>
                        Đã đóng
                    </Typography>
                </Box>
            );
        case CampaignConstants.status.CLIENT_COMPLETED:
            return (
                <Box sx={styles.boxStatus}>
                    <StatusDotBlueIcon />{' '}
                    <Typography component="span" sx={styles.textStatus}>
                        Hoàn thành
                    </Typography>
                </Box>
            );
    }
};

const CampaignStatus: React.FC<{ status: string }> = ({ status }) => {
    return <>{decideComponentStatusDot(status)}</>;
};
const styles = createStyleSheet({
    boxStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    textStatus: {
        fontSize: '14px',
        lineHeight: '17px',
    },
});
export default CampaignStatus;
